import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=4555d907&scoped=true&"
import script from "./Sustainability.vue?vue&type=script&lang=js&"
export * from "./Sustainability.vue?vue&type=script&lang=js&"
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=4555d907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555d907",
  null
  
)

export default component.exports